import React, { useEffect, useState } from 'react'
import { isEmpty, get, set } from 'lodash'

import { ScheduleMeetingModalBoxContainer } from 'pages/Owner/container'
import { ScheduleMeetingWrapper } from 'components/Owner/Plays/style'
import ScheduleMeetingImg from 'assets/svgs/scheduleMeeting.svg'
import ModalBox from 'components/Common/ModalBox'

import { MEETING_STEPPER, PLAY_ACTIONS, supportedPlayIds } from 'config'
import { copy } from 'utils/helper'

const PlaysScheduleMeeting = ({
  data,
  meta,
  user,
  playId,
  tabIndex,
  moveNext,
  playData,
  playStage,
  isScheduled,
  meetingStepper,
  isPlayCompleted,
  setupActiveStepIndex,
  setIsScheduledAction,
  updatePlayStageAction,
  getUserConnectorsAction,
  updateMeetingStepperAction,
  savePlayResponseAction,
  getPlayResponseAction,
  activeStepDataIndex,
  disabled,
}) => {
  const [showModalBox, setShowModalBox] = useState(false)
  const [selectedAdvisorId, setSelectedAdvisorId] = useState<null | string>(null)

  useEffect(() => {
    return () => {
      setIsScheduledAction(false)
    }
  }, [setIsScheduledAction])

  useEffect(() => {
    getUserConnectorsAction()
  }, [getUserConnectorsAction])

  useEffect(() => {
    let tempPlayStage = copy(playStage)
    if (supportedPlayIds.includes(playId)) {
      if (
        isScheduled &&
        !get(
          playStage,
          `[${tabIndex}].steps[${setupActiveStepIndex}].stepData[${activeStepDataIndex}].isMeetingScheduled`,
          ''
        )
      ) {
        setShowModalBox(false)

        const stepData = {
          id: playData.playTabs[tabIndex].tabData.steps[setupActiveStepIndex].stepData[
            activeStepDataIndex
          ].id,
          isMeetingScheduled: isScheduled,
          label:
            playData.playTabs[tabIndex].tabData.steps[setupActiveStepIndex].stepData[
              activeStepDataIndex
            ].stepType,
          isCompleted: true,
        }
        const playResponses = {
          playId,
          tabId: playData.playTabs[tabIndex].id,
          stepData,
          stepDataIndex: activeStepDataIndex,
          stepIndex: setupActiveStepIndex,
          getResponse: false,
        }

        savePlayResponseAction(playResponses)
      } else {
        if (
          isScheduled &&
          !get(tempPlayStage, `[${tabIndex}].steps[${setupActiveStepIndex}].playAction`, '')
        ) {
          setShowModalBox(false)
          set(
            tempPlayStage,
            `[${tabIndex}].steps[${setupActiveStepIndex}].playAction`,
            PLAY_ACTIONS.MEETING_SCHEDULED
          )
          let assessmentResponseObj = {
            userId: user.id,
            type: playId,
            assessmentResponse: [],
            playStage: JSON.stringify(tempPlayStage),
            submitActivity: false,
          }
          updatePlayStageAction(assessmentResponseObj)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScheduled, playStage])

  return (
    <div id="play-schedule-meeting">
      {showModalBox && !isScheduled && (
        <ModalBox
          id="play-schedule-meeting-modal-box"
          onClose={() => {
            setShowModalBox(false)
            setSelectedAdvisorId(null)
            updateMeetingStepperAction({ actionType: 'reset', stepName: MEETING_STEPPER.ADVISOR })
          }}
          title={meetingStepper}
          onBack={
            meetingStepper === MEETING_STEPPER.ADVISOR
              ? undefined
              : () => updateMeetingStepperAction({ actionType: 'decrement' })
          }
        >
          <ScheduleMeetingModalBoxContainer
            setSelectedAdvisorId={setSelectedAdvisorId}
            selectedAdvisorId={selectedAdvisorId}
            setShowModalBox={setShowModalBox}
            selectedClient={null}
          />
        </ModalBox>
      )}

      <ScheduleMeetingWrapper id="schedule-meeting-wrapper">
        <div className="scheduleWrap">
          <img id="schedule-meeting-img" src={ScheduleMeetingImg} alt="ScheduleMeeting" />
          <div className="text-primary-text font-normal text-xl text-center">
            <p className="py-2">{data?.stepHeading?.heading}</p>
            {!isEmpty(data?.stepBody[data?.stepBody.length - 1]?.content)
              ? data?.stepBody?.map((data) => <div>{data?.content}</div>)
              : ``}
          </div>
        </div>
      </ScheduleMeetingWrapper>
    </div>
  )
}

PlaysScheduleMeeting.defaultProps = {
  playData: {},
  moveNext: () => {},
  isPlayCompleted: false,
  disabled: false,
  data: '',
}
export default PlaysScheduleMeeting
